var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex flex-row mt-4"},[_c('div',{staticClass:"pt-2 col-8"},[_vm._t("description")],2),_c('div',{staticClass:"d-flex ml-auto"},[_vm._t("action")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }